import React, { useState } from "react";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { Row, Col, Table } from "reactstrap";
import translate from "../../../../utils/Translator";

const CustomEventAccounts = ({ accounts }) => {
  const options = groupByOption(accounts);

  return (
    <div>
      <h6 className="mb-3">{translate("Account")}s grouped by option</h6>
      {Object.values(options).map((option) => (
        <EventOption key={`opt-${option.id}`} option={option} />
      ))}
    </div>
  );
};

const EventOption = ({ option }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div>
        <Row onClick={() => setOpen(!open)} style={{ cursor: "pointer" }} className="mt-2 mb-3">
          <Col lg="12">
            <div className="d-flex bg-light p-2">
              <span>
                {open ? (
                  <i className="icon-arrow-down icons font-1lg mt-1 mr-2 d-block"></i>
                ) : (
                  <i className="icon-arrow-right icons font-1lg mt-1 mr-2 d-block"></i>
                )}
              </span>
              {option.description}
              <span className="ml-3">
                {" "}
                ({option.items.length}) {translate("Account")}s
              </span>
            </div>
          </Col>
        </Row>
        {open && (
          <Table size="sm">
            <thead>
              <tr>
                <th>{translate("Account")}</th>
                <th className="text-right">Volume</th>
                <th className="text-right">Quantity</th>
                <th className="text-right pr-3">Price</th>
              </tr>
            </thead>
            <tbody>
              {option.items.length > 0 ? (
                option.items.map((acc) => (
                  <tr key={`opt-acc-${acc.id}`}>
                    <td>{acc.account}</td>
                    <td className="text-right">
                      <FormattedNumber value={acc.volume} dataTypeDecimalName="currency" />
                    </td>
                    <td className="text-right">
                      <FormattedNumber value={acc.quantity} dataTypeDecimalName="quantity" />
                    </td>
                    <td className="text-right pr-3">
                      <FormattedNumber value={acc.price} dataTypeDecimalName="price" />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">
                    <h7 className="text-muted text-center p-5" style={{ textAlign: "center" }}>
                      No {translate("Account")}s
                    </h7>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

function groupByOption(accounts) {
  const options = {};

  accounts.forEach((item) => {
    if (!options[item.option]) {
      options[item.option] = {
        id: item.option,
        description: item.optionDescription,
        items: [],
      };

      options[item.option].items.push({
        id: item.accountid,
        account: item.accountname,
        quantity: item.quantity,
        price: item.price,
        volume: item.volume,
      });
    }
  });

  return options;
}

export default CustomEventAccounts;
